<template>
	<v-col>
		<base-material-card>
			<template #heading>
				<div
					:class="
						$vuetify.breakpoint.smAndDown
							? 'text-center display-2 font-weight-light'
							: 'display-2 font-weight-light'
					"
				>
					<span> ניהול פרוייקט </span>
					<span> {{ project.subject }} </span>
				</div>
			</template>
			<form @submit.prevent="onSubmit">
				<smart-input
					v-model="form.subject"
					:errors="inputErrors.subject"
					label="שם פרוייקט"
					required
					maxlength="100"
				/>
				<smart-input
					v-model="form.redirect"
					:errors="inputErrors.redirect"
					label="קישור לאחר התשלום"
					required
				/>
				<v-checkbox
					v-model="form.show_redirect"
					label="הראה קישור מעבר לתשלום בטבלת היסטוריית הרכישות"
				/>
				<smart-input
					v-model="form.description"
					:errors="inputErrors.description"
					textarea
					label="תיאור"
				/>
				<smart-input
					v-model="form.mail_text"
					:errors="inputErrors.mail_text"
					textarea
					label="תוספת למייל"
				/>
				<v-tooltip top>
					<template #activator="{ on, attrs }">
						<div	v-bind="attrs"
							v-on="on">
							<v-switch
								v-model="form.allow_many"
								:label="`אפשר כמה מנויים`"

							>
							</v-switch>
						</div>
					</template>
					<span>אם תאפשר את זה , משתמש אחד יוכל לרכוש כמה מנויים לפרוייקט.</span>
				</v-tooltip>
				<media-gallery-preview v-model="form.image" />
				<v-btn type="submit">
					שמירת נתונים
				</v-btn>
			</form>
		</base-material-card>
	</v-col>
</template>

<script>
import ProjectModule from "src/store/modules/Project.module";
import FormView from "src/mixins/FormView";
import MediaGalleryPreview from "@/components/gallery/MediaGalleryPreview";

export default {
	name: "ProjectForm",
	components: { MediaGalleryPreview },
	mixins: [new FormView(ProjectModule, "project")],
	props: {},
	data() {
		return {
			form: {},
			subjectRules: {
				maxlength: "100"
			}
		};
	},
	created() {
		if (this.$route.params.id) {
			this.$store.dispatch(ProjectModule.types.GET, this.$route.params.id);
		} else {
			this.$store.commit(ProjectModule.types.CREATE, this.$route.params.id);
		}
	},
	methods: {
		onSuccess() {
			this.$router.push({ name: "projects-view" });
			this.$notfication.success();
		}
	}
};
</script>

<style scoped></style>
